import { render } from "./DropDownListPatMotivoBaixa.vue?vue&type=template&id=aaa3d1be&ts=true"
import script from "./DropDownListPatMotivoBaixa.vue?vue&type=script&lang=ts"
export * from "./DropDownListPatMotivoBaixa.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__